import React from 'react';
import ContactForm from './ContactForm';
import './About.css';

const FAQS = [
  {
    question: 'Do I need to create an account to rent?',
    answer:
      'No account needed. Use the Request to Reserve form on any vehicle and we will follow up with next steps.',
  },
  {
    question: 'Where do I pick up the vehicle?',
    answer:
      'Pickup is at our Columbus host location. We will share the exact address and available times once your reservation is confirmed.',
  },
  {
    question: 'Can I request a specific car?',
    answer: 'Yes. Tell us what you are looking for in the contact form below.',
  },
];

function About() {
  return (
    <>
      <section className="about-story">
        <h1>Why Modern Cars</h1>
        <p>
          Modern Cars LLC brings the newest electric and luxury vehicles to Columbus drivers who
          want to try before they commit. Every vehicle is insured and ready for pickup at our
          Columbus location.
        </p>
      </section>

      <section className="about-location">
        <h2>Location and Hours</h2>
        <p>Based in Columbus, Ohio. Pickup by appointment at our host location.</p>
        <p>Reach out below to schedule a time that works for you.</p>
      </section>

      <ContactForm />

      <section className="about-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQS.map(({ question, answer }) => (
          <details key={question} className="about-faq__item">
            <summary>{question}</summary>
            <p>{answer}</p>
          </details>
        ))}
      </section>
    </>
  );
}

export default About;
